import api from './api';

export function getContentBlockImageApiPath(blockId: number): string {
  return `/content-blocks/${blockId}/image/`;
}

/** True when the image file is stored on this platform (not a third-party URL). */
export function isHostedTrainingImage(
  imageUrl: string | null | undefined,
  storagePath?: string | null
): boolean {
  const path = storagePath?.trim();
  if (path) {
    const normalized = path.replace(/^\/+/, '');
    if (normalized.startsWith('training_images/') || normalized.includes('/training_images/')) {
      return true;
    }
  }

  const url = imageUrl?.trim();
  if (!url) {
    return false;
  }

  if (url.startsWith('training_images/')) {
    return true;
  }

  return (
    url.includes('/media/training_images/') ||
    url.includes('/training_images/') ||
    (url.includes('/content-blocks/') && url.includes('/image'))
  );
}

/** Third-party image URL that can be loaded directly in an img tag. */
export function isExternalImageUrl(imageUrl: string | null | undefined): boolean {
  if (!imageUrl?.trim()) {
    return false;
  }
  if (isHostedTrainingImage(imageUrl)) {
    return false;
  }
  return /^https?:\/\//i.test(imageUrl);
}

export function shouldLoadTrainingImageViaApi(
  blockId: number | undefined,
  imageUrl: string | null | undefined,
  storagePath?: string | null
): boolean {
  if (!blockId) {
    return false;
  }
  if (isExternalImageUrl(imageUrl)) {
    return false;
  }
  return Boolean(
    storagePath?.trim() ||
      imageUrl?.trim() ||
      isHostedTrainingImage(imageUrl, storagePath)
  );
}

export async function fetchTrainingImageBlobUrl(blockId: number): Promise<string> {
  const response = await api.get(getContentBlockImageApiPath(blockId), {
    responseType: 'blob',
  });
  const contentType = (response.headers['content-type'] as string | undefined) || '';
  if (!contentType.startsWith('image/')) {
    throw new Error('Invalid image response from server');
  }
  const blob = new Blob([response.data], { type: contentType });
  return URL.createObjectURL(blob);
}

export function revokeTrainingImageBlobUrl(blobUrl: string | null | undefined): void {
  if (blobUrl) {
    URL.revokeObjectURL(blobUrl);
  }
}
